// src/components/Footer.jsx

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function Footer() {
  return (
    <footer className="mt-5">
      <Container>
        <div className="bg-white rounded p-4 shadow-sm">
          <Row>
            <Col md={4} className="mb-4 mb-md-0">
              <div className="fw-bold fs-5 text-primary">OfficeSuppliesME</div>
              <p className="text-muted mt-2">Complete IT & Office Solutions — trusted partner for UAE businesses.</p>
            </Col>
            <Col md={4} className="mb-4 mb-md-0">
              <div className="fw-semibold">Support</div>
              <ul className="list-unstyled mt-2 text-muted">
                <li>Contact Us</li>
                <li>FAQ</li>
                <li>Returns & Warranty</li>
              </ul>
            </Col>
            <Col md={4}>
              <div className="fw-semibold">Business</div>
              <ul className="list-unstyled mt-2 text-muted">
                <li>Corporate Sales</li>
                <li>Partners & Brands</li>
                <li>Careers</li>
              </ul>
            </Col>
          </Row>
          <div className="mt-4 border-top pt-3 text-center text-secondary small">
            © {new Date().getFullYear()} OfficeSuppliesME. All rights reserved.
          </div>
        </div>
      </Container>
    </footer>
  );
}